<template>
  <div class="w-100 mb-3 border-semi-grey radius-12">
    <div class="p-3" :class="!is_variant ? 'border-b-semi-grey' : ''">
      <div class="row no-gutters">
        <div class="col-3" v-if="!isProductImageHidden">
          <div class="w-100" :style="{'height': is_variant ? '45px' : '84px'}">
            <img :src="data.product.data.image_url" class="img-fit radius-6" />
          </div>
        </div>
        <div :class="isProductImageHidden ? 'col-12' : 'col-9'">
          <div class="mb-0 body-2-1" :class="{ 'pl-3': !isProductImageHidden }">{{data.product.data.name}}</div>
          <p class="mb-0 body-3-3-1" :class="{ 'pl-3': !isProductImageHidden }" v-if="is_variant">{{data.variant.length}} {{$pluralWord(data.variant.length,'Variant')}} selected</p>
          <div v-else class="w-100">
            <div class="w-100 mb-2 pl-3"> 
              <p 
                v-if="is_decrease_promo" 
                class="mb-0 text-line-through body-3 d-inline-block align-middle mr-1">
                {{$formatCurrency(promotion_price)}}
              </p>
              <p 
                class="mb-0 body-2-4 text-orange d-inline-block align-middle"
                :class="{
                  'd-inline-block align-middle': is_decrease_promo
                }"
                >
                {{$formatCurrency(final_price)}}
              </p>
            </div>
            <div class="row">
              <div class="col-6 offset-6">
                <div class="plus-min-set text-right">
                  <img src="../../../../assets/img/icon/decrement.png" class="d-inline-block img-crement rounded-100" width="28"
                    style="border:1px solid #70707046;" @click="changeQtyProduct('minus')">
                  <p class="d-inline-block border-none text-center body-2-4 counter mb-0" style="width:35px;">{{qty_cart}}</p>
                  <img src="../../../../assets/img/icon/increment.png" class="d-inline-block border-green img-crement rounded-100"
                    width="28" @click="changeQtyProduct('plus')">
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-12 mt-3" v-if="is_variant">
          <div class="w-100 p-2 radius-6 border-semi-grey" :class="index+1 < data.variant.length ? 'mb-2' : ''" v-for="(variant,index) in data.variant">
            <div class="row no-gutters">
              <div class="col-8 align-self-center">
                <p class="mb-0 body-2-2">{{data.product.variant_type == 'basic' ? variant.data.name : variant.data}}</p>
                <div class="no-ws w-100">
                  <p 
                    v-if="data.product.variant_type == 'basic' ? calcIsDecreasePromo(variant.data.price) : is_decrease_promo" 
                    class="mb-0 text-line-through body-3 d-inline-block align-middle mr-1">
                    {{$formatCurrency(data.product.variant_type == 'basic' ? calPromotionPrice(variant.data.price) : promotion_price)}}
                  </p>
                  <p 
                    class="mb-0 body-2-1 text-orange"
                    :class="{
                      'd-inline-block align-middle': data.product.variant_type == 'basic' ? calcIsDecreasePromo(variant.data.price) : is_decrease_promo
                    }"
                    >
                    {{$formatCurrency(data.product.variant_type == 'basic' ? $calculateFinalPriceConcierge(variant.data.price) : final_price)}}
                  </p>
                </div>
              </div>
              <div class="col-4 align-self-center">
                <div class="plus-min-set text-right">
                  <img src="../../../../assets/img/icon/decrement.png" class="d-inline-block img-crement rounded-100" width="28"
                    style="border:1px solid #70707046;" @click="changeQtyProduct('minus',variant)">
                  <p class="d-inline-block border-none text-center body-2-4 counter mb-0" style="width:35px;">{{variant.qty}}</p>
                  <img src="../../../../assets/img/icon/increment.png" class="d-inline-block border-green img-crement rounded-100"
                    width="28" @click="changeQtyProduct('plus',variant)">
                </div>
              </div>
              <div class="col-12">
                <div class="mt-2 w-100 border-b-semi-grey-dashed">
                </div>
              </div>
              <div class="col-12">
                <div class="w-100 pt-1" @click="toggleNote(variant)">
                  <div class="row no-gutters">
                    <div class="col-11 align-self-center">
                      <p class="w-100 mb-0" style="line-height:1.2 !important;"><span class="body-3-3-1">Note : </span><span class="body-3-1">{{variant.notes == '' ? '-' : variant.notes}}</span></p>
                    </div>
                    <div class="col-1 text-right align-self-center lh-1">
                      <i class="simple-icon-note text-12 text-orange cursor-pointer"></i>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="w-100 px-3 pb-2 pt-1" @click="toggleNote()" v-if="!is_variant">
      <div class="row no-gutters">
        <div class="col-11 align-self-center">
          <p class="w-100 mb-0" style="line-height:1.2 !important;"><span class="body-3-3-1">Note : </span><span class="body-3-1">{{note_product == '' ? '-' : note_product}}</span></p>
        </div>
        <div class="col-1 text-right align-self-center lh-1">
          <i class="simple-icon-note text-12 text-orange cursor-pointer"></i>
        </div>
      </div>
    </div>

    <popup-detail
      direction="bottom" 
      :show="note.show"
      :use_max_size="true"
      wrapper_size="mobile"
      :use_footer="true"
      @close="toggleNote">
      <template v-slot:body>
        <div class="w-100 border-bottom p-3 position-relative">
          <div class="d-inline-block align-middle mr-2" style="width: 45px;height:42px;" v-if="!isProductImageHidden">
            <img :alt="data.product.data.name" :src="data.product.data.image_url" class="img-fit radius-6">
          </div>
          <div class="d-inline-block align-middle w-75">
            <p class="mb-0 body-1-2">{{data.product.data.name}}</p>
            <p class="mb-0 body-3-3-1" v-if="is_variant">Variant : {{note.variant.name ? note.variant.name : note.variant}}</p>
            <div class="w-100" v-else> 
              <p 
                v-if="is_decrease_promo" 
                class="mb-0 text-line-through body-3 d-inline-block align-middle mr-1">
                {{$formatCurrency(promotion_price)}}
              </p>
              <p 
                class="mb-0 body-2-4 text-orange d-inline-block align-middle"
                :class="{
                  'd-inline-block align-middle': is_decrease_promo
                }"
                >
                {{$formatCurrency(final_price)}}
              </p>
            </div>
          </div>
          <div class="bg-white rounded-circle position-absolute border-semi-grey" style="display:inline-flex;padding:10px; right:17px;top:21px;" @click="toggleNote()">
            <img alt="close-icon" src="../../../../assets/img/icon/close.png" width="14" />
          </div>
        </div>
        <div class="p-3">
          <span class="body-3 mb-1 d-block w-100">Notes</span>
          <div class="w-100 position-relative">
            <textarea
              rows="3"
              placeholder="Add some special request"
              class="body-2-1 w-100 border-semi-grey radius-6 input-custom-padding"
              v-model="note.form">
            </textarea>
            <i class="simple-icon-notebook text-semi-dark text-16 position-absolute icon-form-position"></i>
          </div>
        </div>
      </template>
      <template v-slot:footer>
        <div class="px-3 pt-3">
          <state-button
            :click="submitNote" 
            size="lg"
            variant="primary"
            block >
            Save Note
          </state-button>
        </div>
      </template>
    </popup-detail>
  </div>
</template>
<script>
  import {mapGetters,mapMutations} from 'vuex';
  import PopupInputNote from '@/components/hotel/concierge/general/PopupInputNote'

  export default{
    components:{
      PopupInputNote
    },
  	props:{
      data:{
        type: Object,
        default: () => {}
      },
      general_data:{
        type: Object,
        default: () => ({})
      }
    },
    data(){
      return{
        note:{
          show: false,
          form: '',
          variant: {}
        },

        is_note: false,
        note_title: '',
        note_vuex: {
          product_id: '',
          variant_id: '',
          notes: ''
        }
      }
    },
    computed:{
      isProductImageHidden(){
        return this.$isProductImageHidden(this.general_data)
      },
      is_variant(){
        return this.data.variant.length == 0 ? false : true
      },
      base_price(){
        return this.data.product.data.price
      },
      promotion_price(){
        return this.calPromotionPrice(this.base_price)
      },
      is_decrease_promo(){
        return this.calcIsDecreasePromo(this.base_price)
      },
      qty_cart(){
        return this.data.qty
      },
      final_price(){
        return this.$calculateFinalPriceConcierge(this.base_price)
      },
      note_product(){
        return this.is_variant ? this.data.variant[0].notes : this.data.notes
      }
    },
  	methods:{
  		...mapMutations(['removeConciergeOrder','setConciergeOrder','setConciergeOrderNote']),
      changeQtyProduct(type,variant=null){
        let params = {
            product: this.data.product.data,
            variant: variant != null ? variant.data : {},
            qty: variant != null ? variant.qty : this.qty_cart
          }
          if(params.qty == 1 && type == 'minus'){
            this.removeConciergeOrder(params)
          }else{
            if(type == 'minus'){
              params.qty--
            }else{
              params.qty++
            }
            this.setConciergeOrder(params)
          }
      },
      toggleNote(variant=null){
        this.note.show = !this.note.show
        if(this.note.show){
          if(this.is_variant){
            this.note.variant = variant.data
            this.note.form = variant.notes
          }else{
            this.note.form = this.note_product
          }
        }else{
          this.note.variant = {}
          this.note.form = ''
        }
      },
      toggleNoteOld(variant_index=null){
        this.is_note = !this.is_note
        if(this.is_note){
          this.note_title = this.data.product.is_variant ? `[${this.data.variant[variant_index].data.name}] ${this.data.product.data.name}` : this.data.product.data.name
          this.note_vuex = {
            product_id: this.data.product.data.id,
            variant_id: variant_index == null ? '' : this.data.variant[variant_index].data.id,
            notes: variant_index == null ? this.data.notes : this.data.variant[variant_index].notes
          }   
        }else{
          this.note_title = ''
          this.note_vuex = {
            product_id: '',
            variant_id: '',
            notes: ''
          }
        }
      },
      submitNote(notes){
        return new Promise((success,fail)=>{
          let params = {
            product_id: this.data.product.data.id,
            // variant_id: this.is_variant && this.note.variant.id ? this.note.variant.id : '',
            variant_id: !(this.note.variant.id || this.note.variant != '') ? '' : this.data.product.variant_type == 'basic' ? this.note.variant.id : 'variant_notes',
            variant_notes_id: this.is_variant && this.data.product.variant_type == 'notes' ? this.note.variant : '',
            notes: this.note.form
          }
          this.setConciergeOrderNote(params)
          setTimeout(()=>{
            this.toggleNote()
            success()
          },300)
        })
      },
      calPromotionPrice(price){
        if(price.promotion_amount == 0){
          return 0
        }else{
          return price.tax_service_calculation_type == 'INCLUDE' ? price.price_sell_base : price.price_sell
        }
      },
      calcIsDecreasePromo(price){
        if(price.promotion_amount == 0){
          return false
        }else{
          return price.promotion_type == 'INCREASE' ? false : true
        }
      }
  	}
  }
</script>
<style>
  .input-custom-padding{
    padding: 8px 8px 8px 42px;
  }
  .icon-form-position{
    top: 11px;
    left: 12px;
  }
  .img-crement {
    padding: 7px;
    border-radius: 5px;
  }
  @media screen and (max-width: 600px) {
    .plus-min-set {
      margin-left: -20px;
    }
  }
</style>


// WEBPACK FOOTER //
// src/components/hotel/concierge/general/roomDiningMenuCart.vue